/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */

export type InvoicesListKindItem = typeof InvoicesListKindItem[keyof typeof InvoicesListKindItem];


export const InvoicesListKindItem = {
  credit: 'credit',
  invoice: 'invoice',
  proposal: 'proposal',
} as const;
